var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditOutline1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-edit-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160728",
    "data-name": "Group 160728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    "data-name": "Path 4469",
    d: "M22.594,1.407a4.8,4.8,0,0,0-6.791,0L2.383,14.827a.938.938,0,0,0-.24.412L.035,22.811a.937.937,0,0,0,1.159,1.153l7.573-2.151a.937.937,0,0,0,.408-1.564L4.4,15.461,15.524,4.336l4.137,4.137-8.516,8.493a.938.938,0,0,0,1.324,1.328L22.594,8.2a4.8,4.8,0,0,0,0-6.791ZM6.722,20.445,2.289,21.7l1.241-4.46ZM21.269,6.871l-.28.279L16.85,3.011l.278-.278a2.927,2.927,0,0,1,4.14,4.138Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditOutline1);
export default __webpack_public_path__ + "static/media/ic-edit-outline-1.1e9e2275268acaa662a8be07d6769dfd.svg";
export { ForwardRef as ReactComponent };